import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function ContactCTA() {
  return (
    <section
      data-testid="contact-cta"
      className="relative py-24 md:py-40 px-6 md:px-12 max-w-[1440px] mx-auto"
    >
      <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.05 }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
        className="relative rounded-3xl overflow-hidden border border-white/10 bg-[#0D0D11] p-10 md:p-20 grain"
      >
        <div className="absolute -top-40 -right-40 h-[500px] w-[500px] rounded-full bg-[#C48F56] blur-[200px] opacity-30" />
        <div className="absolute -bottom-40 -left-40 h-[400px] w-[400px] rounded-full bg-[#70142A] blur-[180px] opacity-20" />

        <div className="relative grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8">
            <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] text-white/50">
              <span className="h-px w-8 bg-[#C48F56]" />
              Lavoriamo insieme
            </div>
            <h2 className="mt-6 font-display text-5xl md:text-7xl lg:text-8xl tracking-tightest leading-[0.9]">
              Hai un immobile,<br />
              un progetto,<br />
              una <span className="text-[#C48F56]">visione?</span>
            </h2>
            <p className="mt-8 text-white/60 text-lg leading-relaxed max-w-2xl">
              Parliamone. Il nostro team valuta opportunità di sviluppo,
              partnership, joint-venture e progetti di rigenerazione urbana a
              Milano.
            </p>
          </div>
          <div className="lg:col-span-4 flex flex-col gap-3">
            <Link
              to="/contatti"
              data-testid="cta-contact-btn"
              className="group flex items-center justify-between rounded-full bg-white text-black px-6 py-4 text-sm font-medium hover:bg-[#C48F56] transition-colors"
            >
              <span>Contattaci</span>
              <ArrowUpRight
                size={16}
                className="transition-transform group-hover:rotate-45"
              />
            </Link>
            <Link
              to="/investor"
              data-testid="cta-investor-btn"
              className="group flex items-center justify-between rounded-full border border-white/15 px-6 py-4 text-sm hover:bg-white/5 transition-colors"
            >
              <span>Area Investitori</span>
              <ArrowUpRight
                size={16}
                className="transition-transform group-hover:rotate-45"
              />
            </Link>
          </div>
        </div>
      </motion.div>
    </section>
  );
}
